import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveAccountMutation = gql`
   mutation SaveAccount($account: AccountInput!, $deletedNoteIds: [UInt!]!, $hasDeletedNotes: Boolean = false) {
      deleteNotes(ids: $deletedNoteIds) @include(if: $hasDeletedNotes)
      account: saveAccount(account: $account) {
         accountId
         name
         activeStartDate
         activeEndDate
         holdMusicPromptId
         isInternationalDialingEnabled
         isInternationalDialingSuspended
         isCallRecordingFeatureEnabled
         isRecordInternalCalls
         isRecordInboundCalls
         isRecordOutboundCalls
         isMailboxMessageTranscriptionEnabled
         queueManagementStrategyTypeId
         isAgentCanAssign
         isSuspended
         presenceEnabled
         lcsAccountNumber
         isResidential
         callRetentionPolicyTypeId
         nameDirectoryPreferenceId
         pstnLineLimit
         queueManagementStrategyTypeId
         timeZoneId
         operatorExtensionId
         isOtrEnabled
         defaultAreaCode
         logLevelId
         faxFileTypeId
         isMissedCallsShown
         reasonLogLevelChanged
         logLevelChanged
         logLevelChangedByUser {
            username
         }
         isFmFmEnabled
         isLcsInternal
         outboundRecordingNotificationEnabled
         queueManagementStrategyTypeId
         note {
            noteId
            accountId
            notes
            isSystemNote
         }
         scheduleId
      }
   }
`;
